<template>
  <div style="width: 100%; display: flex">
    <el-button @click="dialogObject=true">Импортировать из excel</el-button>
    <el-dialog v-loading="loader" title="Прикрепить excel файл" :visible.sync="dialogObject">
      <el-upload
        style="margin-bottom: 20px"
        v-if="uploadValue === null"
        list-type="picture"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        :http-request="onUpload"
        class="upload-demo"
        action="/"
        :show-file-list="false"
        drag
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">Перетащите файл сюда или <em>нажмите, чтобы загрузить</em></div>
      </el-upload>
      <el-progress v-else :percentage="uploadValue"></el-progress>
      <a href="/static/materials.xlsx">
        <el-button type="primary" @click="dialogObject = false">Скачать шаблон</el-button>

      </a>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogObject = false">Ok</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import {v4 as uuidv4} from 'uuid';

export default {
  name: 'ImportMaterialsFromFile',
  data() {
    return {
      search: '',
      dialogObject: false,
      unit: '',
      uploadValue: null,
      jobs: [],
      loader: false,
      step: 0,
      form: {
        value: '',
        unit: '',
        job: '',
      },
    };
  },
  computed: {
    filteredList() {
      return this.jobs.filter(job => {
        return job.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  methods: {
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = function (error) {
          reject('Error: ', error);
        };
      });
    },
    async onUpload(e) {
      const imageData = await this.getBase64(e.file);

      this.loader = true;

      const proxy = firebase.functions().httpsCallable('onParseMaterials');
      proxy(
        {
          jobs: imageData,
          projectId: this.$store.state.project.id,
          objectId: this.$route.params.id || null,
          // invites: [{
          //   token: token,
          //   email: this.form.email,
          // }],
        },
      ).then((response) => {
        this.$notify({
          title: 'Успешно!',
          message: 'Материалы загружены',
          type: 'success',
        });
        this.dialogObject = false;
        this.$emit('update')
      }).catch((error) => {
        this.$notify({
          title: 'Произошла ошибка',
          message: 'Файл загрузки не соответствует шаблону',
          type: 'error',
        });
      }).finally(() => {
        this.loader = false;
      });
      // const storageRef = firebase.storage(
      // ).ref(`reports/${uuidv4()}`).put(imageData);
      // storageRef.on(`state_changed`, snapshot => {
      //     this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      //   }, error => {
      //     console.log(error.message);
      //   },
      //   () => {
      //     this.uploadValue = 100;
      //     storageRef.snapshot.ref.getDownloadURL().then((url) => {
      //       this.$emit('add-file', url);
      //       this.dialogObject = false;
      //       this.uploadValue = null;
      //     });
      //   },
      // );
    },
    save() {
      this.$emit('add-job', {
        ...this.form,
      });
      this.close();
    },
    close() {
      this.dialogObject = false;
      this.clear();
    },
    clear() {
      this.form.value = '';
      this.form.unit = '';
      this.form.job = '';

      this.step = 0;
    },
  },
};
</script>

<style lang="scss">
.upload-demo {
  margin: 0 auto;
  width: calc(100% - 20px);

  .el-upload {
    width: 100%;
  }

  .el-upload-dragger {
    width: 100%;
    max-width: 360px;
  }
}

.el-upload--picture {
  display: flex;
  justify-content: center;
}

.el-loading-mask {
  position: fixed !important;
  background-color: rgba(255,255,255,.4) !important;
}
</style>





// WEBPACK FOOTER //
// src/views/Dashboard/Jobs/components/ImportMaterialsFromFile.vue